import styled from 'styled-components';
import {Row, Col, Card} from 'react-bootstrap';

export const LoadingStyledNewsItem = styled.div`
    padding-bottom: 10px;
    margin-top: 10px;
`;

export const LoadingStyledNewsItemThumb = styled.div`
    float: left;
    width: 100%;
    margin-right: 10px;
    border-radius: 5px;
    overflow: hidden;
    background-color: #e7e7e7;
    border-radius: 5px;
    min-height: 16rem;
`;

export const LoadingStyledNewsItemTitle = styled.div`
    margin: 5px;

    & h5 {
        background-color: #e7e7e7;
        min-height: 4rem;
        border-radius: 5px;
        margin-bottom: 2rem;
    }

    & p {
        background-color: #ececec;
        border-radius: 5px;
        margin-bottom: 0.5rem;
    }

`;


export const LoadingStyledEventRow = styled(Row)`
    padding-left: 0;
    padding-right: 0;
    width:100%;
    cursor: pointer;
`;

export const LoadingStyledEventPost = styled.div`
    width: 100%;
    float: left;
    border-radius: 5px;
    background: #fff;
    overflow: hidden;
    padding-left: 0;
    padding-right: 0;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
    margin-bottom: 40px;
`;

export const LoadingStyledEventThumb = styled(Col)`
    float: left;
    width: 100%;
    margin-right: 10px;
    border-radius: 5px;
    overflow: hidden;
    background-color: #e7e7e7;
    border-radius-top-left: 5px;
    border-radius-top-right: 5px;
    border-radius-bottom-left: 0px;
    border-radius-bottom-right: 0px;
    min-height: 12rem;
`;

export const LoadingStyledEventText = styled.div`
    text-align: center;
    padding: 1rem;
    & h6 {
        margin-top: 12rem;
        background-color: #e7e7e7;
        min-height: 4rem;
        border-radius: 5px;
        margin-bottom: 2rem;
    }
    & p {
        background-color: #ececec;
        border-radius: 5px;
        margin-bottom: 0.5rem;
    }
`;

export const LoadingNewsListContainer = styled.div`
        padding-right: 10px;
`;


export const LoadingArticleListTag = styled(Card)`
    margin-bottom: 2rem;
    background-color: #f0f0f0;
    border: none;
    border-radius: 5px;

    .tag-pill {
        background-color: #2c5530;
        color: white;
        font-weight: bold;
        font-size: 1.2rem;
        padding: 4px 8px;
        border-radius: 4px;
        text-decoration: none;
        display: inline-block;
    }
    .clear-filter {
        float: right;
        font-size: 1rem;
        text-decoration: none;
    }
`;

export const LoadingListItemContainer = styled.div`
    padding-bottom: 10px;
    margin-top: 10px;
`;

export const LoadingListItemHero = styled.div`
    background-color: #e7e7e7;
    min-height: 18rem;
    border-radius: 5px;
    @media(min-width: 350px) {
        min-height: 8rem;
    }
    @media(min-width: 768px) {
        min-height: 16rem;
    }
    @media(min-width: 1200px) {
        min-height: 18rem;
    }
`;

export const LoadingItemHero = styled.div`
    background-color: #e7e7e7;
    min-height: 18rem;
    border-radius: 5px;
    @media(min-width: 350px) {
        min-height: 8rem;
    }
    @media(min-width: 768px) {
        min-height: 16rem;
    }
    @media(min-width: 1200px) {
        min-height: 20rem;
    }
`;

export const LoadingListItemText = styled.div`
    padding: 1rem;
`;

export const LoadingNewsListStyledIntro = styled.div`
    background-color: #e7e7e7;
    min-height: 4rem;
    border-radius: 5px;
`;


export const LoadingNewsItemTitle = styled.div`
    margin-top: 25px;
    color: var(--forest-green);
    & h2 {
        font-family: "Roboto Slab", serif;
        font-weight: bold;
        background-color:#e7e7e7;
        min-height: 4rem;
        border-radius: 5px;
    }
`;

export const LoadingNewsItemPostMeta = styled.div`
    display: inline;
    list-style: none;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    width: 100%;
`;

export const LoadingStyledIntro = styled.div`
    background-color:#e7e7e7;
    min-height: 4rem;
    border-radius: 5px;
`;

export const LoadingEventListItemContainerRow = styled(Row)`
    box-shadow: 0 6px 20px rgba(0, 0, 0, .15);
    margin-bottom: 40px;
    border-radius: 5px;
    overflow: hidden;
    padding: 5px;
    padding-left: 0;
    padding-right: 10px;
    cursor: pointer;
`;

export const LoadingListItemThumb = styled.div`
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    background-color: #e7e7e7;
    min-height: 12rem;
    overflow: hidden;
    & img {
        width: 100%;
    }
`;


export const LoadingListItemDate = styled(Col)`
    text-align: center;
    background-color: #e7e7e7;
    min-height: 12rem;
`;

export const LoadingEventListItemText = styled(Col)`
    background-color: #e7e7e7;
    min-height: 12rem;
`;


export const LoadingEventItemContainer = styled.div`
    max-width: 1140px;
`;

export const LoadingEventItemDetailHeader = styled.div`
    box-shadow: 0 6px 20px rgba(0, 0, 0, .15);
    margin-bottom: 2rem;
    border-radius: 5px;
    overflow: hidden;
`;


export const LoadingListItemContainerRow = styled(Row)`
    padding: 1rem;
`;

export const LoadingEventItemText = styled(Col)`
    background-color: #e7e7e7;
    min-height: 12rem;
`;

export const LoadingEventItemTitle = styled.div`
    margin-top: 25px;
    background-color: #e7e7e7;
    color: var(--forest-green);
    & h2 {
    font-family: "Roboto Slab", serif;
    font-weight: bold;
    }
`;

export const LoadingEventItemBodySection = styled.section`
    margin-top: 2rem;
    background-color: #e7e7e7;
    min-height: 4rem;
    padding-left: 2rem;
    padding-right: 2rem;
`;


export const LoadingStyledArticleListItem = styled.div`
    padding-bottom: 10px;
    margin-top: 10px;
    border-bottom: dotted 1px #666;
`;

export const LoadingStyledArticleListItemThumb = styled.div`
    float: left;
    width: 100%;
    background-color: #e7e7e7;
    min-height: 16rem;
    margin-right: 10px;
    border-radius: 5px;
    overflow: hidden;
`;

export const LoadingStyledArticleListItemTitle = styled.div`
    margin: 5px;
    min-height: 4rem;
    border-radius: 5px;
    & h5 {
        margin-bottom: 2rem;
        background-color: #e7e7e7;
        min-height: 4rem;
        border-radius: 5px;
    }

    & p {
        background-color: #e7e7e7;
        min-height: 1rem;
        border-radius: 5px;
        margin-bottom: 0.5rem;
    }
`;


export const LoadingArticleItemTitle = styled.div`
    margin-top: 25px;
    color: var(--forest-green);
    & h2 {
        font-family: "Roboto Slab", serif;
        font-weight: bold;
        background-color:#e7e7e7;
        min-height: 4rem;
        border-radius: 5px;
    }
`;